import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useDataProcessorRecordStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        tableHeader: {
            color: theme.palette.primary.dark,
            fontWeight: theme.typography.fontWeightBold,
            fontSize: theme.typography.pxToRem(14),
        },
        searchField: {
            display: "flex",
            justifyContent: "flex-end",
        },
        skeleton: {
            height: 40,
            marginTop: theme.spacing(1),
        },
    });
};
